export default __webpack_public_path__ + "static/woman-watching-sunset-a32af63369440b78be5bacbef7d7bcb5.jpg";